<template lang="pug">
.footer(ref="footer")
  footer
    div.info
      | 网易有道信息技术（北京）有限公司
    .info 北京市海淀区西北旺东路10号院中关村软件园二期西区7号楼A座1层
</template>

<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
    }
  },
}
</script>

<style lang="stylus" scoped="">
.footer
  margin-top: .48rem
  footer
    text-align: center
    font-size: 0.24rem
    .nav
      margin-bottom: .1rem
      .link
        display: inline-block
        color: #606266
        padding: 0 0.1rem
      .link:last-child
        border: 0
      .ins
        border-right: solid 1px $grey
        margin: auto .06rem
    .info
      color: #b3b3b3
    .bannerLink
      display: block
      overflow: hidden
      height: 1.3rem
      .banner
        z-index: 999
        height: 1.3rem
        width: 100%
  .info + .info
    margin-top: 0.1rem
</style>
